export const maxProductQuantityInCart = 999;
